import { render, staticRenderFns } from "./Vlog.vue?vue&type=template&id=0a96135f&scoped=true&"
import script from "./Vlog.vue?vue&type=script&lang=ts&"
export * from "./Vlog.vue?vue&type=script&lang=ts&"
import style0 from "./Vlog.vue?vue&type=style&index=0&id=0a96135f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a96135f",
  null
  
)

/* custom blocks */
import block0 from "./Vlog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports